module.exports = __webpack_public_path__ + "img/map-menu-3@2x.0fe32296.png";